// extracted by mini-css-extract-plugin
export default {"logout":"_logout_logout__NXkt8"};